<template >
  <base-dialog-form ref="gestConvenzioneDialog" :title="computedTitle" :text="convenzione" color="secondary"
    icon="mdi-credit-card-outline">
    <template v-slot:actions v-if="method !== 'VIEW'">
      <v-row>
        <v-col cols="12" class="text-center">
          <v-btn class="mx-5" v-if="method !== 'VIEW'" @click="saveConvenzione" color="success">{{ $t("save") }}</v-btn>
          <v-btn class="mx-5" v-if="method === 'EDIT' && convenzione !== ''" @click="deleteConvenzione" color="error">{{
            $t("delete") }}</v-btn>
        </v-col>
      </v-row>
    </template>
    <v-container>
      <form>
        <v-row>
          <v-col md="3" cols="6">
            <v-text-field :disabled="method !== 'ADD'" v-model="listino.convenzione" :label="$t('code')"
              hide-details="auto"></v-text-field>
          </v-col>

          <v-col md="9" cols="12">
            <v-text-field :disabled="method === 'VIEW'" v-model="listino.descrizione" :label="$t('description')"
              :rules="required" hide-details="auto"></v-text-field>
          </v-col>

          <v-col cols="12" md="6" v-for="(prezzi, affiliazione) in listino.listino" v-bind:key="affiliazione">
            <v-container>
              <v-card elevation="10">
                <v-card-title>
                  <v-row>
                    <v-col cols="8">
                      {{ affiliazione }}<br />{{ prezzi.descr }}</v-col>
                    <v-col cols="2">
                      <v-text-field type="number" v-model="prezzi.prezzo" :disabled="method === 'VIEW'"
                        :label="$t('affiliation_price')" :rules="required" hide-details="auto"></v-text-field>
                    </v-col>
                    <v-col cols="2">
                      <v-text-field type="number" min="0" step="1" v-model="prezzi.crediti"
                        :disabled="method === 'VIEW'" :label="$t('bonus_credits')" :rules="creditiRules"
                        hide-details="auto"></v-text-field>
                    </v-col>
                  </v-row>
                </v-card-title> 
                <v-card-text>
                  <v-container v-for="tessera in prezzi.tessere" v-bind:key="tessera.tesId">
                    <v-card>
                      <v-container>
                        <v-row>
                          <v-col cols="6" md="3">
                            <v-text-field type="number" v-model="tessera.prezzo" :label="$t('price')"
                              hide-details="auto"></v-text-field>
                          </v-col>
                          <v-col cols="6" md="3">
                            <img style="height: 50px" :src="tessera.imgTessera" />
                          </v-col>
                          <v-col cols="12" md="6">
                            <h3 :style="'color: ' + tessera.hexColor + ';'">
                              {{ tessera.nome }}
                            </h3>
                          </v-col>
                        </v-row>
                        <v-row cols="12" v-if="
                          tessera.scontoEta && tessera.scontoEta.length > 0
                        ">
                          <v-col md="6" cols="12" v-for="sconto in tessera.scontoEta" v-bind:key="sconto.id"><v-card>
                              <v-card-text>
                                <v-container>
                                  <v-row>
                                    <v-col md="4" cols="12">
                                      <v-text-field type="number" disabled v-model="sconto.from"
                                        :label="$t('age_from')"></v-text-field>
                                    </v-col>
                                    <v-col md="4" cols="12">
                                      <v-text-field type="number" disabled v-model="sconto.to"
                                        :label="$t('age_to')"></v-text-field></v-col>
                                    <v-col md="4" cols="6">
                                      <v-text-field :rules="required" type="number" :disabled="method === 'VIEW'"
                                        v-model="sconto.prezzo" :label="$t('price')"></v-text-field></v-col>
                                  </v-row></v-container></v-card-text></v-card>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-container>
          </v-col>
        </v-row>
      </form>
    </v-container>
  </base-dialog-form>
</template>
<script>
import Swal from "sweetalert2";

export default {
  name: "gest-convenzione",
  data() {
    return {
      convenzione: null,
      method: null,
      listino: {},
      required: [(value) => !!value || this.$t("required_field")],
      requiredNumber: [
        (value) => (!!value && !isNaN(value)) || this.$t("required_field"),
      ],
      creditiRules: [
        (value) => value !== null && value !== "" && Number.isInteger(Number(value)) && Number(value) >= 0 || this.$t("required_field"),
      ],
    };
  },
  methods: {
    open(method, convenzione) {
      this.method = method;
      this.convenzione = convenzione;
      this.loadData();
      this.$refs.gestConvenzioneDialog.open();
    },
    loadData() {
      let _ = this;
      _.listino = {};
      _.chiamataAxios("GET", "/auth/ente/getConvenzione/" + _.convenzione).then(
        (response) => {
          _.listino = response.data;
          if (_.method === "COPY") {
            _.convenzione = null;
            _.listino.convenzione = null;
            _.method = "ADD";
          }
        }
      );
    },
    deleteConvenzione(item) {
      let _ = this;
      Swal.fire({
        title: this.$t("are_you_sure_?"),
        text: this.$t("you_cant_revert_this"),
        type: "warning",
        showCancelButton: true,
        customClass: "v-application",
        confirmButtonClass:
          "mx-5 v-btn v-btn--contained theme--light v-size--default",
        cancelButtonClass:
          "mx-5 v-btn v-btn--contained theme--light v-size--default",
        confirmButtonText: this.$t("yes_delete"),
        cancelButtonText: this.$t("back"),
        buttonsStyling: true,
      }).then((result) => {
        if (result.value) {
          this.chiamataAxios(
            "DELETE",
            "/auth/ente/deleteConvenzione/" + _.convenzione,
            { dialogLoader: true }
          ).then((response) => {
            if (response.msg.severity > 0) {
              let html = "<strong>" + response.msg.msgTxt + "</strong>"
              Swal.fire({
                type: "success",
                html: html,
              });
              _.$emit("isUpdated", "true");
              _.$refs.gestConvenzioneDialog.close();
            }
          });
        }
      });
    },
    saveConvenzione: function () {
      let _ = this;
      let url = "/auth/ente/saveConvenzione";
      let method = "PUT";

      let saveObj = {
        convenzione: _.listino.convenzione,
        descrizione: _.listino.descrizione,
        listino: {},
      };
      for (let affiliazione in _.listino.listino) {
        let prezzi = _.listino.listino[affiliazione];
        saveObj.listino[affiliazione] = {
          prezzo: prezzi.prezzo,
          crediti: prezzi.crediti,
          tessere: prezzi.tessere.map((tessera) => {
            return {
              tesId: tessera.tesId,
              prezzo: parseFloat(tessera.prezzo),
              scontoEta: tessera.scontoEta,
            };
          }),
        };
      }
      _.chiamataAxios(method, url, { dialogLoader: true, body: saveObj }).then(
        (response) => {
          let html = "<strong>" + response.msg.msgTxt + "</strong>"
          if (response.msg.severity > 0)
            html = "<strong>" + response.msg.msgTxt + "</strong>";
          Swal.fire({
            type: "success",
            html: html,
          });
          _.$emit("isUpdated", "true");
          _.$refs.gestConvenzioneDialog.close();
        }
      );
    },
  },

  computed: {
    computedTitle: function () {
      if (this.method === "EDIT") return this.$t("edit_convention");
      else if (this.method === "VIEW") return this.$t("view_convention");
      else if (this.method === "ADD") return this.$t("create_convention");
      else return "";
    },
  },
};
</script>
